<template>
  <eco-labeled-control :context="contextV2" :attributes="attributes" class="color-control">
    <color-gradient-picker 
      :color-gradient="gradient"
      :disabled="isInteracted"
      @selected="onGradientSelected"
    />
  </eco-labeled-control>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ColorGradientPicker from '@/components/ui/ColorGradientPicker.vue'
import { DeviceModel, MeasuringPointModel, SetMeasuringPointColorInput } from '../../../../../../../eco-domain-store-modules/src/plcOperation/models'
import { EcoLabeledControl } from '@ecocoach/shared-components/src'
import { BaseControlAttributes, ControlContextV2 } from '@ecocoach/shared-components/src/components/deviceControls/v2/models'

const Resource = namespace('resource')
const ParametrizationUi = namespace('parametrizationUi')

@Component({
  components: {
    ColorGradientPicker,
    EcoLabeledControl,
  },
})
export default class MeasuringPointColor extends Vue {
  @Prop() public device: DeviceModel
  @Prop() public measuringPoint: MeasuringPointModel
  @Resource.Getter public dictionary
  @ParametrizationUi.Getter public isInteracted: boolean
  @ParametrizationUi.Action public setMeasuringPointColor: (payload: SetMeasuringPointColorInput) => Promise<void>

  public get contextV2(): ControlContextV2 {
    return {
      resolveStringResource: (resourceKey: string): string => {
        return this.dictionary(resourceKey)
      },
    } as ControlContextV2
  }

  public get attributes() {
    return {
      label: this.device.measuringPoints.length > 1
        ? `${this.dictionary('parameter.chartcolor')}: ${this.dictionary(this.measuringPoint.resourceId || this.fallbackResourceId)}`
        : 'parameter.chartcolor',
      tooltip: 'common.colorincharts.label',
    } as BaseControlAttributes
  }

  // in case no measuring point resource is defined, use a default resource based on the first tag
  public get fallbackResourceId() {
    const tag = this.measuringPoint.tags[0]
    return `MeasuringPoint_${tag}_Name`
  }

  public get gradient() {
    return this.measuringPoint.colorGradient ?? ''
  }

  public onGradientSelected(colorGradient: string) {
    this.setMeasuringPointColor({
      deviceId: this.device.id,
      measuringPointId: this.measuringPoint.id,
      colorGradient,
    } as SetMeasuringPointColorInput)
  }
}
</script>
<style lang="scss" scoped>
.color-control {
  padding-bottom: 15px;
}
</style>
